<div class="container">
    <mat-icon svgIcon="warning-icon"></mat-icon>
    <h1 class="error">{{ 'authorization.error.title' | translate }}</h1>
    <p class="description">{{ 'authorization.error.unauthorized' | translate}}</p>
</div>
